// 点评APP
export default {
  appName: 'dianping',
  useKNB: true,
  sellChannel: 1,
  theme: 'dianping'
};